module.exports = __webpack_public_path__ + "static/media/collect-what-is-rockerbox.e10905f8.png";